import React, { useEffect, useState } from "react";
import "./LogsPage.scss";
import Plot from "react-plotly.js";

interface Props {
    user: string
    activityType: string[];
    activityTime: number[];
}

export default function ActivityTypePlot(props: Props) {
    var data = [{
        values: props.activityTime,
        labels: props.activityType,
        type: "pie",
        textinfo: "label",
        textposition: "outside"
    }];
    var layout = {
        title: {
            text: props.user + " Activities",
            font: {
                size: 20
            }
        },
        showlegend: false
    };

    return (
        <div className="chart-container pie-chart">
            <Plot data={data as any} layout={layout} useResizeHandler={true} style={{ width: '100%', height: '100%' }}/>
        </div>
    )
}
